
export const profile = {
  title: 'Seu Perfil de Personalidade',
  type: 'Tipo de Personalidade',
  traits: 'Características Principais',
  workStyle: 'Estilo de Trabalho',
  communication: 'Estilo de Comunicação',
  basedOnWords: 'Baseado em {{count}} palavras selecionadas',
  behavioralFactors: 'Fatores Comportamentais (D-C-T-O)',
  objectivityFactor: 'Fator de Estilo (S)',
  subjective: 'Subjetivo',
  objective: 'Objetivo'
};

export const chart = {
  percentile: 'º percentil',
  average: 'Média',
  scale: {
    low: 'Baixo',
    middle: 'Médio',
    high: 'Alto'
  }
};

export const traits = {
  assertive: 'Assertivo',
  collaborative: 'Colaborativo',
  outgoing: 'Extrovertido',
  reserved: 'Reservado',
  steady: 'Estável',
  dynamic: 'Dinâmico',
  structured: 'Estruturado',
  flexible: 'Flexível',
  analytical: 'Analítico',
  intuitive: 'Intuitivo',
  visionary: 'Visionário',
  teamOriented: 'Orientado à Equipe',
  systematic: 'Sistemático',
  relationshipBuilder: 'Construtor de Relacionamentos',
  teamBuilder: 'Construtor de Equipe',
  consistentPerformer: 'Desempenho Consistente',
  diplomaticLeader: 'Líder Diplomático',
  changeResistant: 'Resistente à Mudança',
  naturalLeader: 'Líder Natural',
  persuasiveCommunicator: 'Comunicador Persuasivo',
  resultsFocused: 'Focado em Resultados',
  adaptableToChange: 'Adaptável à Mudança',
  relationshipFocused: 'Focado em Relacionamentos',
  structuredApproach: 'Abordagem Estruturada',
  influential: 'Influente',
  networkBuilder: 'Construtor de Redes',
  resultsDriven: 'Orientado a Resultados',
  systematicLeader: 'Líder Sistemático',
  strategicThinker: 'Pensador Estratégico',
  patientInnovator: 'Inovador Paciente',
  peopleFocused: 'Focado em Pessoas',
  patientLeader: 'Líder Paciente',
  measuredRiskTaker: 'Tomador de Riscos Medidos',
  sustainableInnovator: 'Inovador Sustentável',
  technicalExpert: 'Especialista Técnico',
  detailOriented: 'Orientado a Detalhes',
  qualityFocused: 'Focado em Qualidade',
  selfSufficient: 'Autossuficiente',
  goalOriented: 'Orientado a Objetivos',
  persistent: 'Persistente',
  selfMotivated: 'Automotivado',
  processMinded: 'Orientado a Processos',
  selfReliant: 'Autoconfiável',
  quickDecisionMaker: 'Tomador de Decisões Rápidas',
  taskFocused: 'Focado em Tarefas',
  comfortableWithAmbiguity: 'Confortável com Ambiguidade',
  decisive: 'Decisivo',
  efficient: 'Eficiente',
  direct: 'Direto',
  nurturing: 'Cuidadoso',
  organized: 'Organizado',
  inclusive: 'Inclusivo',
  processOriented: 'Orientado a Processos',
  loyal: 'Leal',
  patient: 'Paciente',
  encouraging: 'Encorajador',
  reliable: 'Confiável',
  enthusiastic: 'Entusiasmado',
  persuasive: 'Persuasivo',
  optimistic: 'Otimista',
  social: 'Social',
  spontaneous: 'Espontâneo',
  creative: 'Criativo',
  energetic: 'Energético',
  methodical: 'Metódico',
  thorough: 'Minucioso',
  diplomatic: 'Diplomático',
  consistent: 'Consistente',
  peaceful: 'Pacífico',
  versatile: 'Versátil',
  easyGoing: 'Descontraído',
  supportive: 'Solidário',
  adaptable: 'Adaptável',
  wellRounded: 'Equilibrado',
  situational: 'Situacional'
};

export const personality = {
  inspirationalLeader: {
    type: 'Líder Inspiracional',
    description: 'Líder carismático que constrói equipes estruturadas e estáveis, impulsionando a excelência organizacional'
  },
  commander: {
    type: 'Comandante',
    description: 'Líder forte que valoriza relacionamentos e estabilidade, criando impacto organizacional duradouro'
  },
  executive: {
    type: 'Executivo',
    description: 'Líder comandante e influente que impulsiona resultados através de pessoas e pensamento estratégico'
  },
  dynamicNetworker: {
    type: 'Networker Dinâmico',
    description: 'Construtor de relacionamentos de alta energia que impulsiona mudanças através de networking estruturado e influência sistemática'
  },
  visionaryLeader: {
    type: 'Líder Visionário',
    description: 'Líder comandante que impulsiona inovação através de visão estruturada e execução sistemática'
  },
  socialInnovator: {
    type: 'Inovador Social',
    description: 'Construtor de relacionamentos paciente que cria mudanças através de inovação colaborativa e soluções focadas em pessoas'
  },
  strategicEntrepreneur: {
    type: 'Empreendedor Estratégico',
    description: 'Líder paciente mas decisivo que constrói inovação sustentável através de pensamento estratégico e tomada de riscos medida'
  },
  specialist: {
    type: 'Especialista',
    description: 'Especialista que prefere trabalho estruturado e independente, mantendo altos padrões de qualidade e precisão'
  },
  achiever: {
    type: 'Realizador',
    description: 'Indivíduo orientado a resultados que valoriza consistência e abordagens sistemáticas para alcançar objetivos'
  },
  pioneer: {
    type: 'Pioneiro',
    description: 'Realizador independente que prefere ação direta e prospera em ambientes não estruturados e desafiadores'
  },
  independent: {
    type: 'Independente',
    description: 'Indivíduo automotivado que prefere autonomia e ação direta, mantendo altos padrões pessoais'
  },
  teamBuilder: {
    type: 'Construtor de Equipe',
    description: 'Líder focado em relacionamentos que cria ambientes estruturados e inclusivos onde todos podem prosperar'
  },
  supporter: {
    type: 'Apoiador',
    description: 'Jogador de equipe focado em pessoas que valoriza estabilidade e cria relacionamentos profissionais duradouros e significativos'
  },
  influencer: {
    type: 'Influenciador',
    description: 'Motivador focado em pessoas que abraça mudanças e inspira outros através de entusiasmo e energia positiva'
  },
  networker: {
    type: 'O Conector',
    description: 'Colaborativo e extrovertido, você se destaca construindo relacionamentos e conectando pessoas'
  },
  systematizer: {
    type: 'Sistematizador',
    description: 'Indivíduo orientado a processos que valoriza qualidade, consistência e abordagens sistemáticas para excelência no trabalho'
  },
  facilitator: {
    type: 'Facilitador',
    description: 'Membro estável da equipe que mantém harmonia, constrói consenso e cria ambientes de trabalho colaborativos onde todos se sentem valorizados'
  },
  collaborator: {
    type: 'Colaborador',
    description: 'Jogador de equipe flexível que se adapta perfeitamente a qualquer situação, mantendo dinâmicas de equipe positivas'
  },
  harmonizer: {
    type: 'Harmonizador',
    description: 'Indivíduo adaptável que mantém equilíbrio em todas as situações, promovendo relacionamentos positivos e estabilidade organizacional'
  },
  professional: {
    type: 'Profissional',
    description: 'Demonstra características equilibradas em todas as dimensões comportamentais com abordagem profissional adaptável'
  }
};

export const professional = {
  style: {
    title: 'Estilo Profissional',
    subtitle: 'Sua abordagem natural ao trabalho e colaboração'
  },
  workStyle: {
    title: 'Preferências de Estilo de Trabalho'
  },
  communication: {
    title: 'Estilo de Comunicação'
  }
};

export const workStyle = {
  fastPaced: 'Abordagem dinâmica e acelerada',
  collaborative: 'Orientado à equipe e colaborativo',
  structured: 'Organizado e sistemático',
  flexible: 'Adaptável e flexível',
  adaptable: 'Adaptável a vários ambientes de trabalho',
  balanced: 'Abordagem equilibrada aos desafios do trabalho',
  teamGoals: 'Abordagem estruturada para objetivos de equipe',
  teamInteraction: 'Interação regular da equipe e feedback',
  adaptableProfessional: 'Abordagem profissional adaptável',
  leadsInspiration: 'Lidera através de inspiração e processos estruturados',
  buildsConsensus: 'Constrói consenso enquanto impulsiona resultados',
  strategicLeadership: 'Liderança estratégica com foco em resultados',
  networksSystematic: 'Constrói redes através de gestão sistemática de relacionamentos',
  structuredVision: 'Lidera através de visão estruturada e planejamento sistemático',
  patientInnovation: 'Inovação paciente através de relacionamentos colaborativos',
  strategicEntrepreneurship: 'Empreendedorismo estratégico com execução paciente',
  independentExpertise: 'Expertise independente com abordagem sistemática',
  systematicGoal: 'Alcance sistemático de objetivos e consistência',
  independentAction: 'Ação independente em ambientes dinâmicos',
  autonomousTask: 'Execução autônoma e eficiente de tarefas',
  collaborativeTeam: 'Construção colaborativa de equipe com estrutura',
  supportiveRelationship: 'Abordagem solidária e focada em relacionamentos',
  motivationalAdaptable: 'Abordagem motivacional e adaptável',
  dynamicNetworking: 'Networking dinâmico e construção de relacionamentos',
  systematicQuality: 'Execução sistemática e focada em qualidade',
  harmoniousConsensus: 'Abordagem harmoniosa e construção de consenso',
  flexibleCollaborative: 'Apoio flexível e colaborativo à equipe',
  harmoniousAdaptable: 'Abordagem harmoniosa e adaptável',
  supportiveRole: 'Papel de apoio estruturado e solidário',
  flexibleApproach: 'Abordagem flexível e adaptativa'
};

export const communication = {
  balanced: 'Comunicação equilibrada e reflexiva',
  adaptive: 'Adapta estilo à audiência e situação',
  direct: 'Comunicação clara e direta',
  supportive: 'Encorajador e solidário',
  informal: 'Abordagem informal e direta',
  diplomatic: 'Comunicação diplomática e estruturada',
  consensus: 'Construindo consenso através de discussão',
  enthusiastic: 'Estilo entusiasmado e atrativo',
  situational: 'Estilo de comunicação situacional',
  engagingOrganized: 'Estilo de comunicação atrativo e bem organizado',
  diplomaticDecisive: 'Abordagem de comunicação diplomática mas decisiva',
  persuasiveResults: 'Diálogo persuasivo e orientado a resultados',
  enthusiasticOrganized: 'Estilo de networking entusiasmado e organizado',
  commandingOrganized: 'Estilo de liderança comandante mas organizado',
  collaborativePatient: 'Abordagem colaborativa e paciente centrada em pessoas',
  strategicMeasured: 'Diálogo de liderança estratégico e medido',
  preciseTechnical: 'Estilo de comunicação preciso e técnico',
  clearGoal: 'Diálogo claro e focado em objetivos',
  directAction: 'Intercâmbios diretos e orientados à ação',
  directEfficient: 'Estilo de comunicação direto e eficiente',
  inclusiveSupportive: 'Diálogo inclusivo e solidário',
  encouragingPatient: 'Intercâmbios encorajadores e pacientes',
  enthusiasticPersuasive: 'Estilo entusiasmado e persuasivo',
  socialSpontaneous: 'Intercâmbios sociais e espontâneos',
  methodicalThorough: 'Diálogo metódico e minucioso',
  diplomaticPeaceful: 'Intercâmbios diplomáticos e pacíficos',
  adaptableSupportive: 'Diálogo adaptável e solidário',
  peacefulFlexible: 'Intercâmbios pacíficos e flexíveis',
  conciseAndFocused: 'Comunicação concisa e focada',
  quickResponse: 'Respostas rápidas e diretas',
  informalStyle: 'Estilo informal e acessível'
};
